@if (isVisible()) {
  <app-topbar-icon-button
    (clicked)="openInbox()"
    [icon]="customImage ? '' : 'mail'"
    [image]="customImage"
    iconClass="menu_top_bar__inbox_icon"
    [label]="customTitle"
    [useLabel]="!!customTitle"
    [matBadge]="count()"
    [matBadgeHidden]="count() === 0"
    [matBadgeColor]="'warn'"
    matBadgeSize="small"
    [class]="badgeClass()"
  ></app-topbar-icon-button>
}
